<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Sponsorship Opportunities">
            <AmountSelector />
            <ErrorLabel field="amount" />
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton btnText="Donate" showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  components: {},
  setup(props) {
    const { getValue, settings, setValue, form } = usePaymentForm();

    const params = queryParams();

    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "Emergency Relief (Israel October 23)") {
          setValue("applications.0.subCampaign", "Emergency Relief (Israel October 23)");
        } else if (val == "Zaka Campaign") {
          setValue("applications.0.subCampaign", "Zaka Campaign");
        }  else if (val == "Lone Soldiers") {
          setValue("applications.0.subCampaign", "Lone Soldiers");
        }  else if (val == "Meals for displaced communities") {
          setValue("applications.0.subCampaign", "Meals for Displaced Communities");
        }  else if (val == "Care for displaced children") {
          setValue("applications.0.subCampaign", "Care for Displaced Children");
        }  else if (val == "BBQs and meals for soldiers") {
          setValue("applications.0.subCampaign", "BBQs and Meals for Soldiers");
        } else if (
          val == "Emergency Response Fund" ||
          val == "Aid in Israel October 2023"
        ) {
          setValue("applications.0.subCampaign", "Emergency Response Fund");
        } 
      
        else {
          setValue("applications.0.subCampaign", "Emergency Response Fund");
        }
      }
    );

    return {
      form,
      setValue,
      getValue,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
</style>
